import { render, staticRenderFns } from "./CalendarOptionItems.vue?vue&type=template&id=22595e14&"
import script from "./CalendarOptionItems.vue?vue&type=script&lang=js&"
export * from "./CalendarOptionItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports